export const BACK_OFFICE_BETA_FF = 'back-office-beta';

export const HEADER_TITLE_ID = 'backoffice-section-title';
export const HEADER_SUBTITLE_ID = 'backoffice-section-subtitle';

/** ID to set on the main content section */
export const MAIN_CONTENT_ID = 'maincontent';

export const SCOPE = 'lumx-back-office';
